export const SCROLL_BAR_DEFAULT_SIZE = 12;
//# sourceMappingURL=scroll-bar.js.map